import { render } from "./ImagePickerPlacementImage.vue?vue&type=template&id=003c4f9a"
import script from "./ImagePickerPlacementImage.vue?vue&type=script&lang=js"
export * from "./ImagePickerPlacementImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__